import { createSelector } from 'reselect';

/**
* Является ли пользователь членом родительского комитета
* @param id: идентификатор школы
*/
export const getIsMember = createSelector(
  (state, id) => state.user.committees.includes(parseInt(id, 10)),
  isMember => isMember
);

/**
* Является ли пользователь учеником
*/
export const getIsParent = createSelector(
  state => state.user.type,
  type => (type === 'parent')
);

/**
* Является ли пользователь студентом
*/
export const getIsStudent = createSelector(
  state => state.user.type,
  type => (type === 'student')
);
